import _definePage_default_0 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_3 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/job-card/[id].vue?definePage&vue'
import _definePage_default_4 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/design-wise.vue?definePage&vue'
import _definePage_default_5 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/emb-party-reports.vue?definePage&vue'
import _definePage_default_6 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/fabric-wise.vue?definePage&vue'
import _definePage_default_7 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/job-reports.vue?definePage&vue'
import _definePage_default_8 from '/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/sample-chadar.vue?definePage&vue'

export const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/index.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/admin_master',
    /* internal name: 'admin-master' */
    /* no component */
    children: [
      {
        path: 'menu',
        /* internal name: 'admin-master-menu' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-master-menu',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/admin_master/menu/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roles',
        /* internal name: 'admin-master-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-master-roles',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/admin_master/roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'admin-master-users' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-master-users',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/admin_master/users/index.vue'),
            /* no children */
          },
          {
            path: 'machine-assignment',
            name: 'admin-master-users-machine-assignment',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/admin_master/users/machine-assignment.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/auto-test',
    name: 'auto-test',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/auto-test.vue'),
    /* no children */
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/change-password.vue'),
    /* no children */
  },
  {
    path: '/clear-stock',
    name: 'clear-stock',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/clear-stock.vue'),
    /* no children */
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/dashboard.vue'),
    /* no children */
  },
  {
    path: '/design',
    /* internal name: 'design' */
    /* no component */
    children: [
      {
        path: 'matching',
        name: 'design-matching',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/design/matching.vue'),
        /* no children */
      },
      {
        path: 'scan',
        name: 'design-scan',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/design/scan.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/emb',
    /* internal name: 'emb' */
    /* no component */
    children: [
      {
        path: 'coatingrocess',
        name: 'emb-coatingrocess',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/coatingrocess.vue'),
        /* no children */
      },
      {
        path: 'coatingrocessarko',
        name: 'emb-coatingrocessarko',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/coatingrocessarko.vue'),
        /* no children */
      },
      {
        path: 'delivery',
        name: 'emb-delivery',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/delivery.vue'),
        /* no children */
      },
      {
        path: 'design-stock',
        name: 'emb-design-stock',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/design-stock.vue'),
        /* no children */
      },
      {
        path: 'design-stock-action',
        name: 'emb-design-stock-action',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/design-stock-action.vue'),
        /* no children */
      },
      {
        path: 'embparty',
        name: 'emb-embparty',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/embparty.vue'),
        /* no children */
      },
      {
        path: 'embprocess',
        name: 'emb-embprocess',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/embprocess.vue'),
        /* no children */
      },
      {
        path: 'jactp',
        name: 'emb-jactp',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/jactp.vue'),
        /* no children */
      },
      {
        path: 'loop',
        name: 'emb-loop',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/loop.vue'),
        /* no children */
      },
      {
        path: 'plaintp',
        name: 'emb-plaintp',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/plaintp.vue'),
        /* no children */
      },
      {
        path: 'printitng',
        name: 'emb-printitng',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/printitng.vue'),
        /* no children */
      },
      {
        path: 'stockadjustment',
        name: 'emb-stockadjustment',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/emb/stockadjustment.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/Loader',
    name: 'loader',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/Loader.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/master',
    /* internal name: 'master' */
    /* no component */
    children: [
      {
        path: 'basic-design',
        name: 'master-basic-design',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/basic-design.vue'),
        /* no children */
      },
      {
        path: 'BrokerForm',
        name: 'master-broker-form',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/BrokerForm.vue'),
        /* no children */
      },
      {
        path: 'brokermaster',
        name: 'master-brokermaster',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/brokermaster.vue'),
        /* no children */
      },
      {
        path: 'coating',
        /* internal name: 'master-coating' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'master-coating-id',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/coating/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'create-embroidery-design',
        name: 'master-create-embroidery-design',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/create-embroidery-design.vue'),
        /* no children */
      },
      {
        path: 'create-jacquard-design',
        name: 'master-create-jacquard-design',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/create-jacquard-design.vue'),
        /* no children */
      },
      {
        path: 'delivery',
        /* internal name: 'master-delivery' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'master-delivery-id',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/delivery/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'design',
        name: 'master-design',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/design.vue'),
        /* no children */
      },
      {
        path: 'designmatchings',
        name: 'master-designmatchings',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/designmatchings.vue'),
        /* no children */
      },
      {
        path: 'emb-challan',
        /* internal name: 'master-emb-challan' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'master-emb-challan-id',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/emb-challan/[id].vue'),
            /* no children */
          },
          {
            path: 'invoice-a5',
            /* internal name: 'master-emb-challan-invoice-a5' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'master-emb-challan-invoice-a5-id',
                component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/emb-challan/invoice-a5/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'fabric',
        name: 'master-fabric',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/fabric.vue'),
        /* no children */
      },
      {
        path: 'fabric-images',
        name: 'master-fabric-images',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/fabric-images.vue'),
        /* no children */
      },
      {
        path: 'jacstockdetails',
        name: 'master-jacstockdetails',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/jacstockdetails.vue'),
        /* no children */
      },
      {
        path: 'job-card',
        /* internal name: 'master-job-card' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'master-job-card-id',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/job-card/[id].vue'),
            /* no children */
          },
  _definePage_default_3
  ),
          {
            path: 'JobCardBackwardModal',
            name: 'master-job-card-job-card-backward-modal',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/job-card/JobCardBackwardModal.vue'),
            /* no children */
          },
          {
            path: 'JobCardFlowModal',
            name: 'master-job-card-job-card-flow-modal',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/job-card/JobCardFlowModal.vue'),
            /* no children */
          },
          {
            path: 'JobCardLogsModal',
            name: 'master-job-card-job-card-logs-modal',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/job-card/JobCardLogsModal.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'jobcard',
        name: 'master-jobcard',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/jobcard.vue'),
        /* no children */
      },
      {
        path: 'jobinprocess',
        name: 'master-jobinprocess',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/jobinprocess.vue'),
        /* no children */
      },
      {
        path: 'joboutprocess',
        name: 'master-joboutprocess',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/joboutprocess.vue'),
        /* no children */
      },
      {
        path: 'loop',
        /* internal name: 'master-loop' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'master-loop-id',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/loop/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'paper-images',
        name: 'master-paper-images',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/paper-images.vue'),
        /* no children */
      },
      {
        path: 'partytypemaster',
        name: 'master-partytypemaster',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/partytypemaster.vue'),
        /* no children */
      },
      {
        path: 'paymentterms',
        name: 'master-paymentterms',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/paymentterms.vue'),
        /* no children */
      },
      {
        path: 'processtype',
        name: 'master-processtype',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/processtype.vue'),
        /* no children */
      },
      {
        path: 'producttype',
        name: 'master-producttype',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/producttype.vue'),
        /* no children */
      },
      {
        path: 'purchase-order',
        /* internal name: 'master-purchase-order' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'master-purchase-order-id',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/purchase-order/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'purchaseorder',
        name: 'master-purchaseorder',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/purchaseorder.vue'),
        /* no children */
      },
      {
        path: 'purchaseorder1',
        name: 'master-purchaseorder1',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/purchaseorder1.vue'),
        /* no children */
      },
      {
        path: 'purchaseparty',
        name: 'master-purchaseparty',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/purchaseparty.vue'),
        /* no children */
      },
      {
        path: 'sales-order',
        /* internal name: 'master-sales-order' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'master-sales-order-id',
            component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/sales-order/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'salesparty',
        name: 'master-salesparty',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/salesparty.vue'),
        /* no children */
      },
      {
        path: 'specification',
        name: 'master-specification',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/specification.vue'),
        /* no children */
      },
      {
        path: 'stockdetails',
        name: 'master-stockdetails',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/stockdetails.vue'),
        /* no children */
      },
      {
        path: 'vendorparty',
        name: 'master-vendorparty',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/vendorparty.vue'),
        /* no children */
      },
      {
        path: 'workflow-builder',
        name: 'master-workflow-builder',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/master/workflow-builder.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/purchase-order-action',
    name: 'purchase-order-action',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/purchase-order-action.vue'),
    /* no children */
  },
  {
    path: '/purchase-order-action-arko',
    name: 'purchase-order-action-arko',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/purchase-order-action-arko.vue'),
    /* no children */
  },
  {
    path: '/purchase-order-action-mill',
    name: 'purchase-order-action-mill',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/purchase-order-action-mill.vue'),
    /* no children */
  },
  {
    path: '/purchase-order-action-uncoating',
    name: 'purchase-order-action-uncoating',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/purchase-order-action-uncoating.vue'),
    /* no children */
  },
  {
    path: '/reports',
    /* internal name: 'reports' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'design-wise',
        name: 'reports-design-wise',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/design-wise.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
      {
        path: 'design-wise-report',
        name: 'reports-design-wise-report',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/design-wise-report.vue'),
        /* no children */
      },
      {
        path: 'emb-party-report',
        name: 'reports-emb-party-report',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/emb-party-report.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'emb-party-reports',
        name: 'reports-emb-party-reports',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/emb-party-reports.vue'),
        /* no children */
      },
  _definePage_default_5
  ),
  _mergeRouteRecord(
      {
        path: 'fabric-wise',
        name: 'reports-fabric-wise',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/fabric-wise.vue'),
        /* no children */
      },
  _definePage_default_6
  ),
      {
        path: 'fabric-wise-report',
        name: 'reports-fabric-wise-report',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/fabric-wise-report.vue'),
        /* no children */
      },
      {
        path: 'job-report',
        name: 'reports-job-report',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/job-report.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'job-reports',
        name: 'reports-job-reports',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/job-reports.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'sample-chadar',
        name: 'reports-sample-chadar',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/sample-chadar.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
      {
        path: 'sample-chadar-manage',
        name: 'reports-sample-chadar-manage',
        component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/reports/sample-chadar-manage.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/roles_permissions',
    name: 'roles-permissions',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/roles_permissions.vue'),
    /* no children */
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/whatsapp',
    name: 'whatsapp',
    component: () => import('/home/evara/htdocs/evara.dhola.me/resources/js/pages/whatsapp.vue'),
    /* no children */
  }
]
